<template>
  <g
    id="Main_body_Engine-2"
    v-on:click="changeSeverity('leftMainBodyEngine')"
    :class="severityClass"
  >
    <path
      class="cls-526"
      d="M318.51,51.29l-21.48-5.69c-.48-.13-.81-.56-.8-1.05v-.07c0-.71,.67-1.22,1.36-1.04l21.49,5.7-.57,2.16Z"
    />
    <rect
      class="cls-471"
      x="396.28"
      y="48.02"
      width="4.15"
      height="50"
      transform="translate(-1.36 138.21) rotate(-19.65)"
    />
    <polygon
      class="cls-419"
      points="409.12 99.65 415.44 99.65 424.91 110.35 416.33 126.68 409.12 117.31 409.12 99.65"
    />
    <path
      class="cls-526"
      d="M412.5,104.2l-6.04-16.71c-.49-1.36-2.41-1.4-2.96-.06l-1.82,9.58-2.24,11.76h9.87c.28,0,.55-.03,.81-.1,1.91-.46,3.1-2.51,2.39-4.47Z"
    />
    <path
      class="cls-614"
      d="M377.04,66.54v-18.09h-45.03l-14.63,16.39-.37,5.06h-1.95l-3.63,22.49h23.18l-2.7,1.88,7.09,7.26h23.42l-9.58-11.83c-.38-.46-.94-.73-1.54-.73h-4.19c0-3.01-.02-10.68-.03-16.04h2.88c.75,1.16,1.93,2.02,3.32,2.35v.9c0,.25,.2,.45,.45,.45h1.6c.25,0,.45-.2,.45-.45v-.9c2.57-.6,4.44-3.03,4.16-5.84-.11-1.08-.54-2.08-1.2-2.88h18.27Zm-29.94,3.9c0-.47,0-.89,0-1.27h2.08c-.04,.26-.07,.53-.07,.8,0,.16,.01,.31,.02,.47h-2.04Zm2.42-3.9h.84c-.04,.05-.09,.1-.14,.16h-2.6c.1-.03,.2-.04,.31-.06,.51-.09,1.02-.09,1.54-.09,.02,0,.04,0,.06,0Z"
    />
    <path
      class="cls-392"
      d="M410.11,108.67l-3.31-9.17c-.54-1.5-1.96-2.49-3.55-2.49h-1.57l-2.24,11.76h9.87c.28,0,.55-.03,.81-.1Z"
    />
    <path
      class="cls-159"
      d="M410.86,112.58l-4.51-12.48c-.54-1.5-1.96-2.49-3.55-2.49h-8.51c-.83,0-1.56,.45-1.94,1.13-.19,.33-.3,.71-.3,1.12v.98l4.17,22.23,2.88,1.55,3.4,1.82c1.44,.78,3.24,.63,4.48-.44,2.97-2.57,4.01-6.26,4.36-8.79,.22-1.56,.05-3.15-.48-4.63Z"
    />
    <g>
      <path
        class="cls-526"
        d="M318.64,44.63c-.25,0-.51,.07-.74,.22l-28.21,18.65c-2.95,1.95-4.5,5.22-4.14,8.75,.36,3.52,2.54,6.41,5.83,7.73l58.42,23.38c.69,.28,1.46-.06,1.74-.75,.27-.69-.06-1.46-.75-1.74l-58.42-23.38c-2.35-.94-3.9-3-4.16-5.52-.26-2.52,.85-4.85,2.96-6.24l28.21-18.65c.62-.41,.79-1.24,.38-1.85-.26-.39-.68-.6-1.12-.6Z"
      />
      <path
        class="cls-526"
        d="M289.74,63.57c-2.93,1.94-4.46,5.17-4.1,8.66,.36,3.49,2.51,6.35,5.77,7.66l58.3,23.33c.36,.14,.86,.15,1.17-.03,.06-.03,.12-.06,.17-.1,.17-.12,.32-.3,.4-.51,.11-.28,.11-.58,.01-.83-.09-.35-.47-.7-.83-.84l-58.3-23.33c-2.34-.94-3.91-2.98-4.2-5.48-.04-.35-.05-.7-.04-1.04,.07-2.11,1.09-4.01,2.85-5.25,.05-.06,1.61-1.1,1.67-1.14l26.48-17.51c.55-.36,.89-1.23,.53-1.78-.06-.09-.1-.2-.18-.27-.17-.19-.41-.32-.68-.37-.03,0-.05,0-.08,0-.14-.01-.29,0-.44,.05-.1,.03-.2,.08-.29,.14l-28.21,18.65Z"
      />
      <path
        class="cls-526"
        d="M289.79,63.65c-2.9,1.92-4.42,5.12-4.07,8.58,.35,3.46,2.49,6.29,5.72,7.58l58.18,23.28c.31,.12,.89,.19,1.16,.03,.06-.02,.12-.05,.18-.08,.18-.11,.33-.28,.42-.49,.11-.28,.09-.58-.03-.81-.08-.31-.55-.67-.86-.79l-58.18-23.28c-2.34-.94-3.91-2.96-4.23-5.44-.04-.35-.06-.69-.06-1.04,.03-2.11,1.01-4.03,2.72-5.3,.1-.11,1.53-1.08,1.66-1.17l26.44-17.48c.48-.32,1-1.22,.68-1.7-.05-.08-.05-.2-.13-.26-.12-.19-.32-.35-.58-.41-.03,0-.05-.01-.08-.02-.14-.02-.29-.02-.43,.02-.1,.03-.2,.07-.29,.13l-28.21,18.65Z"
      />
      <path
        class="cls-526"
        d="M289.84,63.72c-2.87,1.9-4.38,5.07-4.03,8.5,.35,3.42,2.47,6.23,5.66,7.51l58.06,23.23c.27,.11,.92,.22,1.15,.09,.06-.01,.12-.04,.18-.07,.19-.09,.34-.26,.43-.47,.11-.28,.07-.58-.07-.79-.07-.26-.62-.63-.9-.74l-58.06-23.23c-2.34-.93-3.91-2.94-4.27-5.41-.05-.34-.07-.69-.07-1.03,0-2.11,.93-4.04,2.58-5.35,.15-.17,1.44-1.06,1.64-1.19l26.4-17.46c.41-.27,1.11-1.21,.83-1.62-.05-.07,0-.2-.07-.25-.07-.18-.23-.37-.47-.46-.02,0-.05-.02-.07-.02-.13-.04-.28-.04-.43,0-.1,.02-.2,.07-.29,.13l-28.21,18.65Z"
      />
      <path
        class="cls-526"
        d="M289.89,63.8c-2.84,1.88-4.33,5.02-3.99,8.41,.35,3.39,2.44,6.17,5.6,7.43l57.94,23.18c.22,.09,.95,.26,1.14,.14,.06,0,.12-.02,.18-.05,.19-.08,.35-.24,.44-.45,.11-.28,.06-.58-.1-.78-.06-.22-.7-.6-.93-.69l-57.94-23.18c-2.33-.93-3.92-2.92-4.31-5.37-.05-.34-.08-.68-.09-1.03-.04-2.11,.85-4.06,2.45-5.4,.2-.22,1.36-1.04,1.62-1.21l26.36-17.43c.34-.23,1.21-1.2,.99-1.54-.04-.06,.04-.2,0-.24-.01-.18-.14-.39-.37-.51-.02-.01-.05-.02-.07-.03-.13-.05-.27-.06-.42-.04-.1,.02-.2,.06-.29,.12l-28.21,18.65Z"
      />
      <path
        class="cls-526"
        d="M289.94,63.87c-2.81,1.86-4.29,4.97-3.95,8.33,.34,3.36,2.42,6.11,5.55,7.36l57.81,23.13c.18,.07,.98,.29,1.13,.2,.06,0,.12-.01,.19-.03,.2-.06,.37-.22,.45-.43,.11-.28,.04-.58-.14-.76-.05-.17-.78-.57-.96-.64l-57.81-23.13c-2.33-.93-3.92-2.9-4.35-5.33-.06-.34-.09-.68-.11-1.02-.07-2.11,.76-4.07,2.31-5.45,.24-.28,1.28-1.02,1.61-1.24l26.33-17.41c.27-.18,1.32-1.19,1.14-1.47-.03-.05,.09-.19,.05-.23,.04-.18-.05-.41-.27-.55-.02-.01-.04-.03-.07-.04-.12-.06-.27-.09-.42-.06-.1,.02-.2,.05-.29,.11l-28.21,18.65Z"
      />
      <path
        class="cls-526"
        d="M289.99,63.95c-2.79,1.84-4.25,4.92-3.91,8.25,.34,3.32,2.39,6.05,5.49,7.29l57.69,23.09c.13,.05,1.01,.33,1.12,.26,.06,0,.13,0,.19-.01,.2-.05,.38-.19,.46-.4,.11-.28,.02-.58-.18-.74-.04-.13-.86-.54-1-.59l-57.69-23.09c-2.32-.93-3.93-2.88-4.38-5.3-.06-.33-.1-.67-.12-1.01-.11-2.12,.68-4.09,2.18-5.51,.29-.33,1.2-1.01,1.59-1.26l26.29-17.38c.21-.14,1.43-1.18,1.29-1.39-.02-.04,.14-.19,.11-.22,.09-.17,.04-.43-.16-.6-.02-.02-.04-.03-.06-.04-.12-.07-.26-.11-.41-.09-.1,.01-.2,.05-.29,.11l-28.21,18.65Z"
      />
      <path
        class="cls-526"
        d="M290.04,64.02c-2.76,1.82-4.2,4.88-3.87,8.16,.34,3.29,2.37,5.99,5.44,7.21l57.57,23.04c.09,.04,1.04,.37,1.11,.32,.06,.01,.13,.01,.19,0,.21-.03,.39-.17,.47-.38,.11-.28,0-.58-.22-.73-.02-.09-.94-.5-1.03-.54l-57.57-23.04c-2.32-.93-3.93-2.86-4.42-5.26-.07-.33-.11-.67-.14-1.01-.15-2.12,.6-4.1,2.05-5.56,.34-.39,1.12-.99,1.57-1.29l26.25-17.36c.14-.09,1.53-1.17,1.44-1.31-.02-.02,.19-.19,.17-.21,.14-.17,.13-.45-.06-.65-.02-.02-.04-.04-.06-.05-.11-.09-.26-.13-.41-.12-.1,0-.2,.04-.29,.1l-28.21,18.65Z"
      />
      <path
        class="cls-526"
        d="M290.09,64.09c-2.73,1.8-4.16,4.83-3.83,8.08,.33,3.25,2.34,5.92,5.38,7.14l57.45,22.99s1.07,.4,1.1,.38c.06,.02,.13,.03,.2,.02,.21-.02,.4-.15,.49-.36,.11-.27,0-.58-.26-.71-.01-.04-1.02-.47-1.06-.49l-57.45-22.99c-2.32-.93-3.94-2.84-4.46-5.22-.07-.33-.12-.66-.15-1-.18-2.12,.52-4.12,1.91-5.61,.39-.44,1.04-.97,1.55-1.31l26.21-17.33c.07-.05,1.64-1.16,1.59-1.23,0-.01,.24-.19,.23-.2,.19-.17,.22-.47,.05-.69-.02-.02-.04-.04-.06-.06-.11-.1-.25-.15-.4-.15-.1,0-.21,.04-.29,.1l-28.21,18.65Z"
      />
      <path
        class="cls-526"
        d="M318.64,45.43c-.1,0-.21,.03-.29,.09l-28.21,18.65c-2.7,1.79-4.12,4.78-3.79,8,.33,3.22,2.32,5.86,5.33,7.07l58.42,23.38c.06,.03,.13,.04,.2,.04,.22,0,.41-.13,.5-.34,.11-.27-.02-.59-.3-.7l-58.42-23.38c-2.63-1.05-4.37-3.36-4.66-6.18-.29-2.82,.95-5.43,3.31-7l28.21-18.65c.25-.16,.31-.5,.15-.74-.1-.15-.27-.24-.45-.24Z"
      />
    </g>
    <path
      class="cls-911"
      d="M406.86,140.85h11.7v.37c0,.71-.58,1.29-1.29,1.29h-9.13c-.71,0-1.29-.58-1.29-1.29v-.37h0Z"
      transform="translate(124.04 -185.54) rotate(29.63)"
    />
    <path
      class="cls-201"
      d="M427.1,141.79h-4.01c-.65,0-1.26,.26-1.71,.72l-1.56,1.6c-.4,.41-1.02,.49-1.51,.21l-19.38-11.12c-.18-.1-.29-.3-.29-.5v-1.51c0-.32,.26-.58,.58-.58h2.23c.58,0,1.11-.31,1.39-.82l13.37-23.52,10.9,3.56v31.97Z"
    />
    <rect class="cls-909" x="341.13" y="80.73" width="29.07" height="6.54" />
    <rect
      class="cls-578"
      x="349.95"
      y="80.23"
      width="5.71"
      height="7.55"
      rx=".65"
      ry=".65"
    />
    <rect
      class="cls-764"
      x="349.95"
      y="80.23"
      width="5.71"
      height="7.55"
      rx=".65"
      ry=".65"
    />
    <path
      class="cls-526"
      d="M380.7,59.6h14.46c2.36,0,4.01-2.34,3.2-4.56l-6.04-16.71c-.49-1.37-2.41-1.4-2.96-.06l-8.67,21.33Z"
    />
    <g>
      <path
        class="cls-201"
        d="M340.76,60.71v-27.03c0-.5-.41-.91-.91-.91h-25.29c-.5,0-.91,.41-.91,.91v16.39c0,.46,.35,.85,.81,.9,2.81,.3,5.23,2.03,6.46,4.51,.5,1.02,1.27,1.88,2.28,2.41l9.06,4.75c.67,.35,1.41,.54,2.17,.54h3.87c1.36,0,2.47-1.11,2.47-2.47Z"
      />
      <path
        class="cls-284"
        d="M313.88,33.94v15.91c0,.47,.35,.86,.81,.92,2.8,.36,5.21,2.12,6.44,4.61,.48,.97,1.2,1.78,2.15,2.28l9.06,4.76c.64,.34,1.35,.51,2.07,.51h3.77c1.28,0,2.32-1.04,2.32-2.32v-26.67c0-.52-.42-.94-.94-.94h-24.76c-.52,0-.94,.42-.94,.94Z"
      />
      <path
        class="cls-189"
        d="M314.12,34.21v15.43c0,.47,.35,.87,.81,.95,2.79,.42,5.19,2.2,6.42,4.71,.45,.92,1.14,1.68,2.03,2.15l9.07,4.76c.61,.32,1.29,.49,1.98,.49h3.67c1.2,0,2.18-.98,2.18-2.18v-26.31c0-.53-.43-.97-.97-.97h-24.23c-.53,0-.97,.43-.97,.97Z"
      />
      <path
        class="cls-352"
        d="M314.36,34.48v14.95c0,.48,.34,.89,.81,.97,2.78,.48,5.17,2.29,6.41,4.82,.42,.86,1.07,1.58,1.9,2.02l9.08,4.77c.58,.3,1.22,.46,1.88,.46h3.57c1.12,0,2.04-.91,2.04-2.04v-25.95c0-.55-.45-1-1-1h-23.69c-.55,0-1,.45-1,1Z"
      />
      <path
        class="cls-407"
        d="M314.59,34.74v14.47c0,.48,.34,.9,.82,.99,2.77,.55,5.15,2.37,6.39,4.92,.4,.81,1,1.48,1.78,1.89l9.09,4.77c.55,.29,1.16,.44,1.78,.44h3.47c1.04,0,1.89-.85,1.89-1.89v-25.59c0-.57-.46-1.02-1.02-1.02h-23.16c-.57,0-1.02,.46-1.02,1.02Z"
      />
      <path
        class="cls-335"
        d="M314.83,35.01v13.98c0,.49,.34,.91,.82,1.02,2.76,.61,5.13,2.46,6.37,5.03,.37,.76,.93,1.38,1.65,1.76l9.09,4.77c.52,.27,1.1,.42,1.68,.42h3.37c.96,0,1.75-.78,1.75-1.75v-25.23c0-.58-.47-1.05-1.05-1.05h-22.63c-.58,0-1.05,.47-1.05,1.05Z"
      />
      <path
        class="cls-327"
        d="M315.07,35.27v13.5c0,.49,.34,.92,.82,1.04,2.76,.66,5.11,2.54,6.35,5.13,.34,.71,.86,1.28,1.53,1.63l9.1,4.78c.49,.26,1.03,.39,1.59,.39h3.27c.88,0,1.6-.72,1.6-1.6v-24.87c0-.6-.48-1.08-1.08-1.08h-22.09c-.6,0-1.08,.48-1.08,1.08Z"
      />
      <path
        class="cls-340"
        d="M315.31,35.54v13.02c0,.5,.34,.94,.82,1.06,2.75,.72,5.09,2.63,6.34,5.23,.32,.66,.8,1.18,1.4,1.5l9.11,4.78c.46,.24,.97,.37,1.49,.37h3.17c.8,0,1.46-.65,1.46-1.46v-24.51c0-.61-.5-1.11-1.11-1.11h-21.56c-.61,0-1.11,.5-1.11,1.11Z"
      />
      <path
        class="cls-357"
        d="M315.55,35.81v12.54c0,.51,.33,.95,.82,1.09,2.74,.78,5.07,2.72,6.32,5.34,.29,.61,.73,1.08,1.28,1.37l9.11,4.78c.43,.23,.91,.34,1.39,.34h3.07c.72,0,1.31-.59,1.31-1.31v-24.15c0-.63-.51-1.14-1.14-1.14h-21.03c-.63,0-1.14,.51-1.14,1.14Z"
      />
      <path
        class="cls-375"
        d="M315.78,36.07v12.06c0,.51,.33,.96,.82,1.11,2.73,.84,5.05,2.8,6.3,5.44,.26,.55,.66,.98,1.15,1.24l9.12,4.79c.4,.21,.84,.32,1.3,.32h2.97c.64,0,1.17-.52,1.17-1.17v-23.79c0-.65-.52-1.17-1.17-1.17h-20.5c-.65,0-1.17,.52-1.17,1.17Z"
      />
    </g>
    <path
      class="cls-110"
      d="M424.01,114.42c.59,.34,1.15,.72,1.67,1.16,.57,.48,.49,1.03,.52,1.7,.04,.93-.24,1.89-.67,2.7-.75,1.42-1.5,2.84-2.25,4.25-1.37,2.59-2.75,5.18-4.12,7.77-.04,.07-.39,.9-.48,.9h1.1c.26,0,.46,.2,.48,.46h.33c.24,0,.45,.16,.52,.38,.38,.08,.68,.98,.68,2.08s-.3,1.99-.68,2.08c-.08,.22-.28,.38-.52,.38h-.33c-.02,.25-.22,.46-.48,.46h-4.18l-.13,.25c-.07,.13-.17,.24-.28,.32-.28,.21-.66,.25-.98,.07l-5.21-2.76c-.45-.24-.63-.81-.39-1.26,.49-.93,.98-1.86,1.48-2.79,1.14-2.15,2.28-4.3,3.42-6.45,1.26-2.39,2.53-4.77,3.79-7.16,.87-1.64,1.74-3.28,2.6-4.91,.12-.23,.29-.74,.55-.86,.36-.16,1.16,.21,1.52,.33,.54,.18,1.07,.41,1.58,.67,.16,.08,.31,.16,.46,.25Z"
    />
    <g>
      <ellipse class="cls-908" cx="420.97" cy="136.25" rx=".74" ry="2.09" />
      <path
        class="cls-910"
        d="M419.85,133.8h0c.67,0,1.22,.55,1.22,1.22v2.46c0,.67-.55,1.22-1.22,1.22h0v-4.9h0Z"
      />
    </g>
    <path
      class="cls-471"
      d="M413.32,133.34h5.55c.72,0,1.31,.59,1.31,1.31v3.2c0,.72-.59,1.31-1.31,1.31h-5.55v-5.82h0Z"
    />
    <g>
      <ellipse class="cls-201" cx="333.74" cy="80.7" rx="11.06" ry="14.58" />
      <ellipse class="cls-284" cx="333.77" cy="80.64" rx="10.88" ry="14.37" />
      <ellipse class="cls-189" cx="333.81" cy="80.58" rx="10.69" ry="14.16" />
      <ellipse class="cls-352" cx="333.85" cy="80.53" rx="10.5" ry="13.95" />
      <path
        class="cls-407"
        d="M333.89,66.73c5.69,0,10.32,6.16,10.32,13.74s-4.62,13.74-10.32,13.74-10.32-6.16-10.32-13.74,4.62-13.74,10.32-13.74Z"
      />
      <path
        class="cls-335"
        d="M333.92,66.88c5.59,0,10.13,6.06,10.13,13.53s-4.54,13.53-10.13,13.53-10.13-6.06-10.13-13.53,4.54-13.53,10.13-13.53Z"
      />
      <path
        class="cls-327"
        d="M333.96,67.03c5.49,0,9.94,5.97,9.94,13.32s-4.46,13.32-9.94,13.32-9.95-5.97-9.95-13.32,4.46-13.32,9.95-13.32Z"
      />
      <path
        class="cls-340"
        d="M334,67.19c5.38,0,9.76,5.88,9.76,13.11s-4.38,13.11-9.76,13.11-9.76-5.88-9.76-13.11,4.38-13.11,9.76-13.11Z"
      />
      <path
        class="cls-357"
        d="M334.03,67.34c5.28,0,9.57,5.79,9.57,12.9s-4.29,12.9-9.57,12.9-9.57-5.79-9.57-12.9,4.29-12.9,9.57-12.9Z"
      />
      <path
        class="cls-375"
        d="M334.07,67.49c-5.18,0-9.39,5.69-9.39,12.69s4.21,12.69,9.39,12.69,9.39-5.69,9.39-12.69-4.21-12.69-9.39-12.69Z"
      />
    </g>
    <path
      class="cls-4"
      d="M324.21,78.8c0,7.49,4.61,13.57,10.29,13.57,3.64,0,6.84-2.5,8.67-6.26-1.59,4.8-5.21,8.16-9.44,8.16-5.68,0-10.29-6.07-10.29-13.57,0-2.69,.6-5.2,1.62-7.31-.55,1.66-.85,3.48-.85,5.41Z"
    />
    <g>
      <path
        class="cls-201"
        d="M291.74,66.31c-1.82,1.2-2.92,3.28-2.75,5.45,.18,2.27,1.57,4.14,3.67,4.99l22.72,9.09c2.71,1.09,5.67-.91,5.67-3.84v-7.87c0-5.01-.44-10.01-1.33-14.93l-.21-1.17c-.76-4.26-5.64-6.35-9.25-3.96l-18.52,12.24Z"
      />
      <path
        class="cls-283"
        d="M319.42,58.01c-.42-2.33-2.09-3.99-4.09-4.6-.85-.26-1.76-.33-2.66-.18-.79,.12-1.66,.46-2.39,.94l-18.29,12.09c-1.73,1.14-2.97,3.25-2.8,5.31,.04,1.11,.38,2.15,.98,3.03,.61,.88,1.47,1.58,2.54,2l22.5,9c2.35,.94,5.15-.45,5.59-2.82,.05-.23,.08-.47,.09-.72,.03,0,.07-1.75,.07-1.79v-6.16c0-5.01-.44-10.01-1.33-14.94l-.21-1.17Z"
      />
      <path
        class="cls-284"
        d="M319.32,57.99c-.41-2.31-2.09-3.93-4.06-4.51-.84-.25-1.74-.3-2.62-.14-.75,.11-1.65,.49-2.35,.95l-18.06,11.94c-1.64,1.09-3.02,3.21-2.86,5.18-.02,1.09,.28,2.14,.85,3.03s1.44,1.62,2.51,2.04l22.28,8.91c2.23,.89,5.16-.32,5.58-2.57,.06-.22,.1-.44,.12-.68,.07,0,.14-1.69,.14-1.78v-6.26c0-5.01-.44-10.01-1.33-14.94l-.21-1.17Z"
      />
      <path
        class="cls-304"
        d="M319.22,57.97c-.41-2.29-2.08-3.88-4.02-4.42-.83-.23-1.72-.28-2.59-.1-.71,.11-1.65,.52-2.31,.95l-17.82,11.79c-1.56,1.03-3.07,3.18-2.92,5.04-.08,1.07,.17,2.13,.72,3.03s1.41,1.65,2.49,2.08l22.06,8.83c2.12,.85,5.18-.19,5.57-2.32,.07-.2,.11-.42,.14-.64,.1,0,.21-1.63,.21-1.76v-6.36c0-5.01-.44-10.01-1.33-14.94l-.21-1.18Z"
      />
      <path
        class="cls-282"
        d="M319.11,57.94c-.41-2.26-2.08-3.82-3.99-4.34-.83-.22-1.69-.25-2.55-.07-.67,.1-1.64,.55-2.27,.96l-17.59,11.63c-1.47,.97-3.11,3.15-2.97,4.91-.13,1.05,.07,2.12,.59,3.04s1.38,1.69,2.47,2.12l21.84,8.74c2,.8,5.19-.05,5.56-2.07,.07-.19,.13-.39,.16-.6,.14,0,.29-1.57,.29-1.75v-6.46c0-5.01-.44-10.01-1.33-14.94l-.21-1.18Z"
      />
      <path
        class="cls-189"
        d="M319.01,57.92c-.4-2.24-2.07-3.76-3.96-4.25-.82-.21-1.67-.22-2.51-.03-.63,.09-1.64,.58-2.23,.96l-17.36,11.48c-1.38,.92-3.16,3.12-3.03,4.77-.19,1.04-.04,2.1,.46,3.04s1.35,1.73,2.44,2.16l21.62,8.65c1.88,.75,5.2,.08,5.55-1.82,.08-.17,.14-.36,.19-.56,.17,0,.36-1.51,.36-1.73v-6.56c0-5.01-.44-10.01-1.33-14.94l-.21-1.18Z"
      />
      <path
        class="cls-348"
        d="M318.91,57.9c-.4-2.22-2.06-3.71-3.92-4.16-.81-.19-1.65-.2-2.47,.01-.59,.09-1.64,.61-2.19,.97l-17.13,11.33c-1.3,.86-3.21,3.08-3.08,4.63-.25,1.02-.14,2.09,.33,3.05s1.32,1.77,2.42,2.21l21.4,8.56c1.76,.71,5.21,.21,5.54-1.57,.09-.16,.16-.33,.21-.52,.21,0,.43-1.45,.43-1.72v-6.66c0-5.01-.44-10.01-1.33-14.94l-.21-1.18Z"
      />
      <path
        class="cls-352"
        d="M318.81,57.88c-.39-2.2-2.06-3.65-3.89-4.08-.8-.18-1.63-.17-2.43,.05-.56,.08-1.63,.63-2.15,.97l-16.9,11.17c-1.21,.8-3.26,3.05-3.14,4.5-.3,1-.24,2.08,.2,3.05s1.29,1.8,2.4,2.25l21.18,8.47c1.65,.66,5.23,.34,5.53-1.32,.09-.14,.17-.3,.23-.47,.24,0,.5-1.4,.5-1.71v-6.75c0-5.01-.45-10.02-1.33-14.94l-.21-1.18Z"
      />
      <path
        class="cls-396"
        d="M318.71,57.86c-.39-2.17-2.05-3.59-3.86-3.99-.79-.17-1.6-.14-2.39,.09-.52,.08-1.63,.66-2.11,.98l-16.67,11.02c-1.12,.74-3.31,3.02-3.2,4.36-.36,.98-.35,2.07,.07,3.05s1.26,1.84,2.37,2.29l20.96,8.39c1.53,.61,5.24,.47,5.53-1.07,.1-.12,.19-.27,.26-.43,.28,0,.57-1.34,.57-1.69v-6.85c0-5.01-.45-10.02-1.33-14.94l-.21-1.19Z"
      />
      <path
        class="cls-329"
        d="M318.61,57.83c-.39-2.15-2.05-3.54-3.82-3.9-.78-.16-1.58-.12-2.36,.12-.48,.07-1.62,.69-2.06,.98l-16.43,10.87c-1.04,.69-3.35,2.99-3.25,4.23-.41,.96-.45,2.05-.06,3.06s1.23,1.88,2.35,2.33l20.74,8.3c1.41,.56,5.25,.6,5.52-.83,.11-.11,.2-.24,.28-.39,.31,0,.64-1.28,.64-1.68v-6.95c0-5.01-.45-10.02-1.33-14.95l-.21-1.19Z"
      />
      <path
        class="cls-320"
        d="M318.51,57.81c-.38-2.13-2.04-3.48-3.79-3.82-.77-.14-1.56-.09-2.32,.16-.44,.07-1.62,.72-2.02,.99l-16.2,10.71c-.95,.63-3.4,2.95-3.31,4.09-.47,.94-.55,2.04-.18,3.06s1.2,1.92,2.33,2.37l20.52,8.21c1.29,.52,5.27,.73,5.51-.58,.11-.09,.22-.21,.3-.35,.34,0,.72-1.22,.72-1.66v-7.05c0-5-.45-10.02-1.33-14.95l-.21-1.19Z"
      />
      <path
        class="cls-317"
        d="M318.41,57.79c-.38-2.1-2.04-3.42-3.76-3.73-.76-.13-1.54-.07-2.28,.2-.4,.06-1.62,.75-1.98,.99l-15.97,10.56c-.87,.57-3.45,2.92-3.37,3.96-.53,.92-.66,2.03-.31,3.07,.36,1.09,1.17,1.95,2.3,2.41l20.29,8.12c1.18,.47,5.28,.86,5.5-.33,.12-.08,.23-.18,.33-.31,.38,0,.79-1.16,.79-1.65v-7.15c0-5-.45-10.02-1.33-14.95l-.21-1.19Z"
      />
      <path
        class="cls-309"
        d="M318.31,57.77c-.37-2.08-2.03-3.37-3.72-3.64-.75-.12-1.51-.04-2.24,.24-.36,.05-1.61,.78-1.94,1l-15.74,10.41c-.78,.51-3.5,2.89-3.42,3.82-.58,.9-.76,2.02-.44,3.07,.34,1.11,1.14,1.99,2.28,2.45l20.07,8.03c1.06,.42,5.29,.99,5.49-.08,.13-.06,.24-.15,.35-.26,.41,0,.86-1.1,.86-1.64v-7.25c0-5-.45-10.02-1.33-14.95l-.21-1.19Z"
      />
      <path
        class="cls-224"
        d="M318.21,57.75c-.37-2.06-2.02-3.31-3.69-3.56-.75-.1-1.49-.01-2.2,.28-.32,.05-1.61,.81-1.9,1l-15.51,10.25c-.69,.46-3.55,2.86-3.48,3.68-.64,.88-.87,2.01-.57,3.07,.31,1.13,1.11,2.03,2.26,2.49l19.85,7.94c.94,.38,5.31,1.12,5.48,.17,.13-.05,.26-.12,.38-.22,.45,0,.93-1.04,.93-1.62v-7.35c0-5-.45-10.02-1.33-14.95l-.21-1.19Z"
      />
      <path
        class="cls-327"
        d="M318.11,57.73c-.36-2.04-2.02-3.25-3.66-3.47-.74-.09-1.47,.01-2.16,.31-.28,.04-1.6,.84-1.86,1.01l-15.28,10.1c-.61,.4-3.59,2.82-3.53,3.55-.7,.86-.97,1.99-.7,3.08,.29,1.15,1.07,2.07,2.23,2.53l19.63,7.86c.82,.33,5.32,1.25,5.47,.42,.14-.03,.27-.09,.4-.18,.48,0,1-.99,1-1.61v-7.45c0-5-.45-10.03-1.33-14.95l-.21-1.2Z"
      />
      <path
        class="cls-323"
        d="M318,57.7c-.36-2.01-2.01-3.2-3.63-3.38-.73-.08-1.45,.04-2.13,.35-.24,.04-1.6,.87-1.82,1.01l-15.04,9.95c-.52,.34-3.64,2.79-3.59,3.41-.75,.84-1.08,1.98-.83,3.08,.26,1.18,1.04,2.1,2.21,2.57l19.41,7.77c.71,.28,5.33,1.38,5.46,.67,.15-.02,.29-.06,.42-.14,.52,0,1.07-.93,1.07-1.59v-7.55c0-5-.45-10.03-1.33-14.95l-.21-1.2Z"
      />
      <path
        class="cls-338"
        d="M317.9,57.68c-.36-1.99-2.01-3.14-3.59-3.29-.72-.06-1.43,.06-2.09,.39-.2,.03-1.6,.9-1.78,1.02l-14.81,9.79c-.43,.29-3.69,2.76-3.65,3.28-.81,.82-1.18,1.97-.96,3.09,.24,1.2,1.01,2.14,2.19,2.61l19.19,7.68c.59,.24,5.35,1.51,5.46,.92,.15,0,.3-.03,.45-.1,.55,0,1.14-.87,1.14-1.58v-7.64c0-5-.45-10.03-1.33-14.96l-.22-1.2Z"
      />
      <path
        class="cls-390"
        d="M317.8,57.66c-.35-1.97-2-3.09-3.56-3.21-.71-.05-1.4,.09-2.05,.43-.16,.02-1.59,.93-1.74,1.02l-14.58,9.64c-.35,.23-3.74,2.73-3.7,3.14-.87,.8-1.29,1.96-1.09,3.09,.21,1.22,.98,2.18,2.16,2.65l18.97,7.59c.47,.19,5.36,1.64,5.45,1.17,.16,.01,.31-.08,.47-.06,.58,.09,1.22-.81,1.22-1.57v-7.74c0-5-.45-10.03-1.33-14.96l-.22-1.2Z"
      />
      <path
        class="cls-411"
        d="M317.7,57.64c-.35-1.95-2-3.03-3.53-3.12-.7-.04-1.38,.12-2.01,.47-.12,.02-1.59,.96-1.7,1.03l-14.35,9.49c-.26,.17-3.78,2.69-3.76,3-.92,.78-1.39,1.95-1.22,3.09,.18,1.24,.95,2.22,2.14,2.69l18.75,7.5c.35,.14,5.37,1.77,5.44,1.42,.17,.03,.33-.03,.49-.01,.61,.07,1.29-.75,1.29-1.55v-7.84c0-5-.45-10.03-1.33-14.96l-.22-1.2Z"
      />
      <path
        class="cls-358"
        d="M317.6,57.62c-.34-1.92-1.99-2.97-3.49-3.03-.69-.03-1.36,.14-1.97,.5-.08,.01-1.58,.98-1.66,1.03l-14.12,9.33c-.17,.11-3.83,2.66-3.82,2.87-.98,.76-1.5,1.93-1.35,3.1,.16,1.26,.92,2.25,2.12,2.73l18.53,7.42c.24,.09,5.39,1.9,5.43,1.67,.17,.04,.34,.02,.52,.03,.65,.05,1.36-.69,1.36-1.54v-7.94c0-5-.45-10.03-1.33-14.96l-.22-1.21Z"
      />
      <path
        class="cls-263"
        d="M317.5,57.59c-.34-1.9-1.98-2.92-3.46-2.95-.68-.01-1.34,.17-1.93,.54-.04,0-1.58,1.01-1.62,1.04l-13.89,9.18c-.09,.06-3.88,2.63-3.87,2.73-1.03,.74-1.6,1.92-1.48,3.1,.13,1.28,.89,2.29,2.09,2.77l18.31,7.33c.12,.05,5.4,2.04,5.42,1.92,.18,.06,.36,.06,.54,.07,.69,.02,1.43-.64,1.43-1.52v-8.04c0-5-.45-10.03-1.33-14.96l-.22-1.21Z"
      />
      <path
        class="cls-375"
        d="M313.97,54.71c-.68,0-1.31,.2-1.9,.58l-19.16,12.67c-1.09,.72-1.71,1.91-1.61,3.1,.11,1.3,.86,2.33,2.07,2.81l23.5,9.4c.19,.07,.38,.11,.56,.11,.72,0,1.5-.58,1.5-1.51v-8.14c0-5-.45-10.04-1.33-14.96l-.22-1.21c-.34-1.88-1.98-2.86-3.43-2.86Z"
      />
    </g>
    <path
      class="cls-4"
      d="M312.12,55.35l-18.69,12.1c-1.44,.93-2.25,2.49-2.12,4.06,.14,1.69,1.19,3.08,2.81,3.74l23.2,9.36c-.84,.32-1.81,.34-2.74-.03l-20.95-8.38c-1.94-.78-3.22-2.5-3.39-4.6-.16-2,.86-3.92,2.53-5.03l17.08-11.29c1.37-.91,2.94-1.11,4.37-.76-.74,.13-1.46,.41-2.1,.83Z"
    />
    <path
      class="cls-912"
      d="M384.97,78.19h7.08c1.34,0,2.44,1.09,2.44,2.44v4.59c0,1.34-1.09,2.44-2.44,2.44h-7.08v-9.46h0Z"
    />
    <g>
      <polygon
        class="cls-420"
        points="388.63 79.44 365.45 79.44 367.72 73.14 386.36 73.14 388.63 79.44"
      />
      <rect class="cls-420" x="369.62" y="71.06" width="14.85" height="14.76" />
      <path
        class="cls-420"
        d="M367.74,81.14l-4.74,10.34h28.08l-4.69-10.25c-.03-.06-.08-.09-.15-.09h-18.51Z"
      />
      <g>
        <path
          class="cls-907"
          d="M364.87,85.21l.31-.68c.03-.06,.08-.09,.15-.09h23.42c.06,0,.12,.04,.15,.09l.31,.68c.05,.11-.03,.23-.15,.23h-24.05c-.12,0-.19-.12-.15-.23Z"
        />
        <path
          class="cls-922"
          d="M388.09,82.77l.31,.68c.05,.11-.03,.23-.15,.23h-22.44c-.12,0-.19-.12-.15-.23l.31-.68c.03-.06,.08-.09,.15-.09h21.81c.06,0,.12,.04,.15,.09Z"
        />
        <path
          class="cls-921"
          d="M392.07,91.48c.14,.44-.18,.91-.66,.91h-28.74c-.48,0-.8-.47-.66-.91h30.06Z"
        />
        <path
          class="cls-920"
          d="M362.45,90.5l.31-.68c.03-.06,.08-.09,.15-.09h28.26c.06,0,.12,.04,.15,.09l.31,.68c.05,.11-.03,.23-.15,.23h-28.89c-.12,0-.19-.12-.15-.23Z"
        />
        <path
          class="cls-915"
          d="M366.49,81.69l.44-.96c.14-.3,.44-.5,.78-.5h18.68c.34,0,.64,.2,.78,.5l.44,.96c.05,.11-.03,.23-.15,.23h-20.82c-.12,0-.19-.12-.15-.23Z"
        />
        <path
          class="cls-919"
          d="M364.06,86.97l.31-.68c.03-.06,.08-.09,.15-.09h25.04c.06,0,.12,.04,.15,.09l.31,.68c.05,.11-.03,.23-.15,.23h-25.66c-.12,0-.19-.12-.15-.23Z"
        />
        <path
          class="cls-916"
          d="M363.26,88.74l.31-.68c.03-.06,.08-.09,.15-.09h26.65c.06,0,.12,.04,.15,.09l.31,.68c.05,.11-.03,.23-.15,.23h-27.28c-.12,0-.19-.12-.15-.23Z"
        />
      </g>
      <path
        class="cls-420"
        d="M369.26,71.72l-4.57-11.93,24.56,.32-4.4,11.52c-.02,.06-.07,.09-.12,.09h-15.47Z"
      />
      <g>
        <path
          class="cls-914"
          d="M366.87,67.08l.26,.76c.02,.06,.07,.1,.12,.1h19.59c.05,0,.1-.04,.12-.1l.26-.76c.04-.12-.02-.25-.12-.25h-20.11c-.1,0-.16,.13-.12,.25Z"
        />
        <path
          class="cls-917"
          d="M386.28,69.8l.26-.76c.04-.12-.02-.25-.12-.25h-18.76c-.1,0-.16,.13-.12,.25l.26,.76c.02,.06,.07,.1,.12,.1h18.24c.05,0,.1-.04,.12-.1Z"
        />
        <path
          class="cls-928"
          d="M389.61,60.1c.12-.49-.15-1.01-.55-1.01h-24.03c-.4,0-.67,.52-.55,1.01h25.13Z"
        />
        <path
          class="cls-918"
          d="M364.84,61.2l.26,.76c.02,.06,.07,.1,.12,.1h23.63c.05,0,.1-.04,.12-.1l.26-.76c.04-.12-.02-.25-.12-.25h-24.16c-.1,0-.16,.13-.12,.25Z"
        />
        <path
          class="cls-927"
          d="M368.21,71l.37,1.07c.12,.34,.37,.56,.65,.56h15.62c.28,0,.53-.22,.65-.56l.37-1.07c.04-.12-.02-.25-.12-.25h-17.41c-.1,0-.16,.13-.12,.25Z"
        />
        <path
          class="cls-925"
          d="M366.19,65.12l.26,.76c.02,.06,.07,.1,.12,.1h20.93c.05,0,.1-.04,.12-.1l.26-.76c.04-.12-.02-.25-.12-.25h-21.46c-.1,0-.16,.13-.12,.25Z"
        />
        <path
          class="cls-931"
          d="M365.52,63.16l.26,.76c.02,.06,.07,.1,.12,.1h22.28c.05,0,.1-.04,.12-.1l.26-.76c.04-.12-.02-.25-.12-.25h-22.81c-.1,0-.16,.13-.12,.25Z"
        />
      </g>
      <path
        class="cls-924"
        d="M366.95,73.93l.26-.68c.02-.06,.07-.09,.12-.09h19.42c.05,0,.1,.04,.12,.09l.26,.68c.04,.11-.02,.23-.12,.23h-19.94c-.1,0-.16-.12-.12-.23Z"
      />
      <path
        class="cls-930"
        d="M364.94,79.22l.26-.68c.02-.06,.07-.09,.12-.09h23.43c.05,0,.1,.04,.12,.09l.26,.68c.04,.11-.02,.23-.12,.23h-23.95c-.1,0-.16-.12-.12-.23Z"
      />
      <path
        class="cls-932"
        d="M366.28,75.69l.26-.68c.02-.06,.07-.09,.12-.09h20.76c.05,0,.1,.04,.12,.09l.26,.68c.04,.11-.02,.23-.12,.23h-21.28c-.1,0-.16-.12-.12-.23Z"
      />
      <path
        class="cls-929"
        d="M365.61,77.46l.26-.68c.02-.06,.07-.09,.12-.09h22.1c.05,0,.1,.04,.12,.09l.26,.68c.04,.11-.02,.23-.12,.23h-22.61c-.1,0-.16-.12-.12-.23Z"
      />
      <rect
        class="cls-730"
        x="371.94"
        y="62.52"
        width="9.85"
        height="6.42"
        rx="2.08"
        ry="2.08"
      />
      <g>
        <g>
          <rect
            class="cls-2"
            x="371.59"
            y="62.85"
            width="9.85"
            height="6.42"
            rx="2.08"
            ry="2.08"
          />
          <rect
            class="cls-56"
            x="371.63"
            y="62.9"
            width="9.75"
            height="6.33"
            rx="1.95"
            ry="1.95"
          />
          <rect
            class="cls-225"
            x="371.68"
            y="62.95"
            width="9.66"
            height="6.23"
            rx="1.82"
            ry="1.82"
          />
          <path
            class="cls-191"
            d="M373.42,62.99h6.18c.94,0,1.69,.76,1.69,1.69v2.75c0,.94-.76,1.69-1.69,1.69h-6.17c-.94,0-1.69-.76-1.69-1.69v-2.75c0-.94,.76-1.69,1.69-1.69Z"
          />
          <path
            class="cls-130"
            d="M373.34,63.04h6.34c.86,0,1.57,.7,1.57,1.57v2.91c0,.86-.7,1.57-1.57,1.57h-6.34c-.86,0-1.57-.7-1.57-1.57v-2.91c0-.86,.7-1.57,1.57-1.57Z"
          />
          <path
            class="cls-163"
            d="M373.26,63.09h6.5c.79,0,1.44,.64,1.44,1.44v3.07c0,.79-.64,1.44-1.44,1.44h-6.5c-.79,0-1.44-.64-1.44-1.44v-3.07c0-.79,.64-1.44,1.44-1.44Z"
          />
          <path
            class="cls-661"
            d="M373.18,63.14h6.66c.72,0,1.31,.59,1.31,1.31v3.23c0,.72-.59,1.31-1.31,1.31h-6.66c-.72,0-1.31-.59-1.31-1.31v-3.23c0-.72,.59-1.31,1.31-1.31Z"
          />
          <path
            class="cls-89"
            d="M373.1,63.18h6.82c.65,0,1.18,.53,1.18,1.18v3.39c0,.65-.53,1.18-1.18,1.18h-6.82c-.65,0-1.18-.53-1.18-1.18v-3.39c0-.65,.53-1.18,1.18-1.18Z"
          />
          <path
            class="cls-502"
            d="M373.02,63.23h6.98c.58,0,1.05,.47,1.05,1.05v3.55c0,.58-.47,1.05-1.05,1.05h-6.98c-.58,0-1.06-.47-1.06-1.06v-3.55c0-.58,.47-1.05,1.05-1.05Z"
          />
          <path
            class="cls-441"
            d="M372.94,63.28h7.14c.51,0,.93,.42,.93,.93v3.71c0,.51-.41,.93-.93,.93h-7.14c-.51,0-.93-.42-.93-.93v-3.71c0-.51,.42-.93,.93-.93Z"
          />
        </g>
        <path
          class="cls-756"
          d="M373.64,67.94c0,.36-.29,.65-.65,.65s-.65-.29-.65-.65,.29-.65,.65-.65,.65,.29,.65,.65Z"
        />
        <path
          class="cls-784"
          d="M373.64,64.19c0-.36-.29-.65-.65-.65s-.65,.29-.65,.65,.29,.65,.65,.65,.65-.29,.65-.65Z"
        />
        <path
          class="cls-783"
          d="M379.38,67.94c0,.36,.29,.65,.65,.65s.65-.29,.65-.65-.29-.65-.65-.65-.65,.29-.65,.65Z"
        />
        <path
          class="cls-782"
          d="M379.38,64.19c0-.36,.29-.65,.65-.65s.65,.29,.65,.65-.29,.65-.65,.65-.65-.29-.65-.65Z"
        />
        <path
          class="cls-441"
          d="M373.52,67.94c0,.29-.24,.53-.53,.53s-.53-.24-.53-.53,.24-.53,.53-.53,.53,.24,.53,.53Z"
        />
        <path
          class="cls-441"
          d="M373.52,64.19c0-.29-.24-.53-.53-.53s-.53,.24-.53,.53,.24,.53,.53,.53,.53-.24,.53-.53Z"
        />
        <path
          class="cls-441"
          d="M379.5,67.94c0,.29,.24,.53,.53,.53s.53-.24,.53-.53-.24-.53-.53-.53-.53,.24-.53,.53Z"
        />
        <path
          class="cls-441"
          d="M379.5,64.19c0-.29,.24-.53,.53-.53s.53,.24,.53,.53-.24,.53-.53,.53-.53-.24-.53-.53Z"
        />
      </g>
      <path
        class="cls-785"
        d="M374.66,61.56h3.71c.51,0,.93,.42,.93,.93v7.14c0,.51-.41,.93-.93,.93h-3.71c-.51,0-.93-.42-.93-.93v-7.14c0-.51,.42-.93,.93-.93Z"
        transform="translate(442.57 -310.45) rotate(90)"
      />
      <rect
        class="cls-835"
        x="367.63"
        y="95"
        width="2.97"
        height="1.82"
        rx=".91"
        ry=".91"
      />
      <path
        class="cls-831"
        d="M363.52,92.39h11.19c0,2.07-1.68,3.75-3.75,3.75h-3.69c-2.07,0-3.75-1.68-3.75-3.75h0Z"
      />
      <path
        class="cls-829"
        d="M375.03,92.39h1.7v5.09c0,.37-.3,.68-.68,.68h-.35c-.37,0-.68-.3-.68-.68v-5.09h0Z"
      />
      <rect
        class="cls-830"
        x="383.48"
        y="95"
        width="2.97"
        height="1.82"
        rx=".91"
        ry=".91"
        transform="translate(769.94 191.83) rotate(180)"
      />
      <path
        class="cls-833"
        d="M383.12,92.39h3.69c2.07,0,3.75,1.68,3.75,3.75h-11.19c0-2.07,1.68-3.75,3.75-3.75Z"
        transform="translate(769.94 188.53) rotate(-180)"
      />
      <path
        class="cls-834"
        d="M378.02,92.39h.35c.37,0,.68,.3,.68,.68v5.09h-1.7v-5.09c0-.37,.3-.68,.68-.68Z"
        transform="translate(756.39 190.55) rotate(180)"
      />
    </g>
    <g>
      <path
        class="cls-832"
        d="M352.9,60.43h26.37c6.07,0,10.98-4.92,10.98-10.98h0c0-6.07-4.92-10.98-10.98-10.98h-26.37c-6.07,0-10.98,4.92-10.98,10.98h0c0,6.07,4.92,10.98,10.98,10.98Z"
      />
      <g>
        <circle class="cls-773" cx="345.57" cy="47.28" r="1.56" />
        <path
          class="cls-828"
          d="M346.75,47.28c0,.65-.53,1.18-1.18,1.18s-1.18-.53-1.18-1.18,.53-1.18,1.18-1.18,1.18,.53,1.18,1.18Z"
        />
        <circle class="cls-767" cx="366.8" cy="41.33" r="1.56" />
        <path
          class="cls-859"
          d="M367.98,41.33c0,.65-.53,1.18-1.18,1.18s-1.18-.53-1.18-1.18,.53-1.18,1.18-1.18,1.18,.53,1.18,1.18Z"
        />
        <circle class="cls-769" cx="345.57" cy="51.61" r="1.56" />
        <path
          class="cls-858"
          d="M346.75,51.61c0,.65-.53,1.18-1.18,1.18s-1.18-.53-1.18-1.18,.53-1.18,1.18-1.18,1.18,.53,1.18,1.18Z"
        />
      </g>
      <circle
        class="cls-857"
        cx="366.8"
        cy="53.9"
        r="3.75"
        transform="translate(229.71 398.36) rotate(-76.66)"
      />
      <path
        class="cls-533"
        d="M363.32,53.57c0,2.07,1.68,3.75,3.75,3.75,1.11,0,2.11-.49,2.79-1.25-.68,.96-1.79,1.59-3.06,1.59-2.07,0-3.75-1.68-3.75-3.75,0-.96,.36-1.83,.95-2.49-.43,.61-.69,1.35-.69,2.16Z"
      />
    </g>
    <path
      class="cls-392"
      d="M404.36,108.57s-3.07-8.73-10.4-9.67c-.42-.05-.96-.11-1.62-.16-.19,.33-.3,.71-.3,1.12v.98l4.17,22.23,2.88,1.55c10.43-5.27,5.25-16.05,5.25-16.05Z"
    />
    <g id="Full_tank-2">
      <path
        class="cls-863"
        d="M385.28,126.81l-11.69-.67-.07,1.23c-.03,.57,.38,1.06,.95,1.13l9.51,1.11c.62,.07,1.16-.39,1.2-1.01l.1-1.8Z"
      />
      <g>
        <path
          class="cls-315"
          d="M341.52,103.6c-1.26,2.05-.41,9.93,14.74,17.97,8.74,4.64,26.96,8.12,37.6,5.28,15.87-4.23,9.45-17.6,9.45-17.6,0,0-3.07-8.73-10.4-9.67-4.9-.63-27.08-1.33-40.68,.08-6.76,.7-9.27,1.58-10.72,3.94Z"
        />
        <path
          class="cls-317"
          d="M341.61,103.62c-1.22,2.01-.36,9.8,14.67,17.78,5.31,2.82,14.13,5.19,22.56,5.98,2.44,.22,4.83,.32,7.1,.25,3.03-.1,5.81-.53,8.17-1.22,15.13-4.44,8.99-17.15,8.99-17.15,0,0-.02-.04-.04-.11-.01-.03-.03-.08-.05-.12-.53-1.34-3.64-8.51-10.2-9.35-2.87-.37-11.74-.77-21.3-.74-6.6,.02-13.61,.24-19.2,.81-.67,.07-1.3,.14-1.89,.21-5.39,.67-7.52,1.59-8.8,3.67Z"
        />
        <path
          class="cls-335"
          d="M341.71,103.65c-1.18,1.97-.3,9.67,14.6,17.58,5.35,2.84,14.3,5.23,22.75,5.97,2.47,.21,4.89,.29,7.15,.19,3.08-.14,5.84-.68,8.15-1.42,14.39-4.63,8.53-16.69,8.53-16.7,0,0-.02-.05-.04-.11-.01-.03-.03-.08-.05-.12-.5-1.27-3.59-8.43-10.08-9.27-2.86-.37-11.69-.76-21.21-.74-6.51,.02-13.51,.23-19.12,.8-.67,.07-1.3,.14-1.89,.21-5.42,.67-7.52,1.58-8.78,3.61Z"
        />
        <path
          class="cls-308"
          d="M341.8,103.68c-1.14,1.93-.25,9.54,14.53,17.38,5.4,2.86,14.47,5.26,22.94,5.96,2.51,.2,4.94,.26,7.2,.13,3.13-.18,5.86-.83,8.13-1.63,13.64-4.8,8.06-16.24,8.06-16.24,0,0-.02-.05-.04-.11-.01-.03-.03-.08-.05-.12-.48-1.21-3.53-8.35-9.97-9.18-2.85-.37-11.64-.76-21.12-.74-6.42,.02-13.42,.22-19.04,.79-.66,.07-1.29,.14-1.88,.21-5.46,.67-7.53,1.57-8.76,3.56Z"
        />
        <path
          class="cls-228"
          d="M341.9,103.7c-1.1,1.89-.19,9.4,14.46,17.18,5.44,2.89,14.64,5.29,23.13,5.96,2.55,.19,5,.24,7.26,.07,3.18-.23,5.88-.98,8.11-1.83,12.9-4.94,7.6-15.78,7.6-15.79,0,0-.02-.05-.04-.11-.01-.03-.03-.09-.05-.12-.45-1.14-3.48-8.28-9.86-9.1-2.83-.37-11.6-.76-21.03-.73-6.34,.02-13.32,.22-18.96,.78-.66,.07-1.28,.13-1.87,.21-5.49,.67-7.54,1.56-8.74,3.5Z"
        />
        <path
          class="cls-224"
          d="M341.99,103.73c-1.05,1.85-.14,9.27,14.38,16.98,5.49,2.91,14.81,5.34,23.32,5.95,2.58,.19,5.05,.21,7.31,.02,3.23-.27,5.9-1.13,8.09-2.04,12.15-5.06,7.14-15.33,7.13-15.34,0,0-.02-.06-.05-.12,0-.03-.03-.09-.05-.12-.43-1.08-3.42-8.2-9.75-9.01-2.82-.36-11.55-.75-20.94-.73-6.25,.01-13.22,.21-18.87,.77-.65,.07-1.27,.13-1.86,.2-5.53,.66-7.54,1.54-8.72,3.44Z"
        />
        <path
          class="cls-222"
          d="M342.09,103.75c-1.01,1.81-.09,9.14,14.31,16.78,5.54,2.94,14.98,5.37,23.5,5.94,2.62,.18,5.11,.18,7.37-.04,3.28-.32,5.92-1.28,8.07-2.24,11.41-5.15,6.68-14.88,6.67-14.89,0,0-.03-.06-.05-.12,0-.02-.03-.09-.05-.13-.4-1.02-3.37-8.12-9.64-8.93-2.81-.36-11.5-.75-20.84-.73-6.17,.01-13.13,.21-18.79,.76-.65,.06-1.27,.13-1.85,.2-5.56,.66-7.55,1.53-8.7,3.39Z"
        />
        <path
          class="cls-327"
          d="M342.18,103.78c-.97,1.77-.03,9.01,14.24,16.58,5.58,2.96,15.15,5.4,23.69,5.93,2.66,.16,5.16,.15,7.42-.1,3.33-.36,5.94-1.42,8.05-2.45,10.67-5.22,6.21-14.42,6.21-14.44,0,0-.03-.07-.05-.12,0-.02-.03-.09-.05-.13-.38-.95-3.32-8.04-9.52-8.84-2.79-.36-11.45-.75-20.75-.73-6.08,.01-13.03,.2-18.71,.75-.65,.06-1.26,.13-1.84,.2-5.6,.66-7.56,1.52-8.68,3.33Z"
        />
        <path
          class="cls-325"
          d="M342.28,103.8c-.93,1.72,.02,8.87,14.17,16.38,5.63,2.99,15.33,5.43,23.88,5.92,2.7,.15,5.22,.12,7.47-.16,3.38-.41,5.95-1.56,8.03-2.65,9.93-5.25,5.75-13.97,5.74-13.98,0,0-.03-.07-.05-.12,0-.02-.04-.1-.05-.13-.35-.89-3.26-7.96-9.41-8.76-2.78-.36-11.41-.74-20.66-.72-5.99,.01-12.94,.19-18.63,.74-.64,.06-1.25,.13-1.84,.2-5.63,.66-7.56,1.51-8.66,3.28Z"
        />
        <path
          class="cls-323"
          d="M342.37,103.83c-.89,1.68,.07,8.74,14.1,16.18,5.68,3.01,15.5,5.46,24.07,5.91,2.73,.14,5.27,.09,7.53-.21,3.43-.46,5.97-1.69,8.01-2.86,9.2-5.26,5.29-13.51,5.28-13.53,0,0-.03-.07-.05-.12,0-.02-.04-.1-.05-.13-.33-.83-3.21-7.89-9.3-8.67-2.76-.36-11.36-.74-20.57-.72-5.91,.01-12.84,.19-18.55,.73-.64,.06-1.25,.13-1.83,.19-5.67,.66-7.57,1.5-8.64,3.22Z"
        />
        <path
          class="cls-345"
          d="M342.47,103.85c-.85,1.64,.13,8.61,14.03,15.99,5.72,3.04,15.67,5.49,24.26,5.9,2.77,.13,5.33,.06,7.58-.27,3.48-.51,5.98-1.83,7.98-3.06,8.48-5.24,4.82-13.06,4.81-13.08,0,0-.03-.08-.05-.12,0-.02-.04-.1-.05-.13-.3-.76-3.15-7.81-9.19-8.59-2.75-.36-11.31-.73-20.48-.72-5.82,0-12.74,.18-18.47,.72-.63,.06-1.24,.12-1.82,.19-5.7,.65-7.57,1.49-8.62,3.16Z"
        />
        <path
          class="cls-338"
          d="M342.56,103.88c-.81,1.6,.18,8.48,13.96,15.79,5.77,3.06,15.84,5.52,24.45,5.89,2.81,.12,5.38,.03,7.64-.33,3.52-.55,6-1.95,7.96-3.27,7.77-5.19,4.36-12.61,4.35-12.63,0,0-.04-.08-.05-.12,0-.02-.04-.11-.05-.13-.27-.7-3.1-7.73-9.07-8.5-2.74-.35-11.26-.73-20.39-.72-5.74,0-12.65,.17-18.38,.71-.63,.06-1.23,.12-1.81,.19-5.74,.65-7.58,1.47-8.6,3.11Z"
        />
        <path
          class="cls-367"
          d="M342.66,103.9c-.77,1.56,.24,8.34,13.88,15.59,5.81,3.09,16.01,5.55,24.63,5.88,2.84,.11,5.44,0,7.69-.39,3.57-.6,6.02-2.08,7.94-3.47,7.08-5.11,3.9-12.15,3.89-12.18,0,0-.04-.08-.05-.12,0-.01-.04-.11-.05-.13-.25-.64-3.04-7.65-8.96-8.42-2.72-.35-11.21-.73-20.29-.72-5.65,0-12.55,.17-18.3,.7-.62,.06-1.23,.12-1.8,.19-5.77,.65-7.59,1.46-8.58,3.05Z"
        />
        <path
          class="cls-390"
          d="M342.75,103.93c-.72,1.52,.29,8.21,13.81,15.39,5.86,3.11,16.18,5.58,24.82,5.87,2.88,.1,5.49-.04,7.74-.44,3.62-.65,6.03-2.2,7.92-3.68,6.39-5.01,3.44-11.7,3.42-11.72,0,0-.04-.09-.05-.12,0-.01-.04-.11-.05-.13-.22-.57-2.99-7.58-8.85-8.33-2.71-.35-11.17-.72-20.2-.71-5.56,0-12.46,.16-18.22,.7-.62,.06-1.22,.12-1.79,.18-5.81,.65-7.59,1.45-8.56,3Z"
        />
        <path
          class="cls-372"
          d="M342.85,103.95c-.68,1.48,.34,8.08,13.74,15.19,5.91,3.13,16.35,5.61,25.01,5.86,2.92,.09,5.55-.07,7.8-.5,3.67-.7,6.06-2.31,7.9-3.88,5.73-4.88,2.97-11.24,2.96-11.27,0,0-.04-.09-.05-.12,0-.01-.04-.11-.05-.13-.2-.51-2.94-7.5-8.74-8.25-2.7-.35-11.12-.72-20.11-.71-5.48,0-12.36,.16-18.14,.69-.62,.06-1.21,.12-1.79,.18-5.84,.65-7.6,1.44-8.54,2.94Z"
        />
        <path
          class="cls-411"
          d="M342.94,103.98c-.64,1.44,.4,7.95,13.67,14.99,5.95,3.16,16.52,5.64,25.2,5.85,2.95,.07,5.6-.1,7.85-.56,3.72-.75,6.09-2.41,7.88-4.09,5.08-4.73,2.51-10.79,2.5-10.82,0,0-.04-.1-.05-.12,0,0-.04-.12-.05-.13-.17-.44-2.88-7.42-8.62-8.16-2.68-.35-11.07-.72-20.02-.71-5.39,0-12.26,.15-18.06,.68-.61,.06-1.2,.12-1.78,.18-5.88,.64-7.61,1.43-8.52,2.88Z"
        />
        <path
          class="cls-410"
          d="M343.04,104.01c-.6,1.4,.45,7.82,13.6,14.79,6,3.18,16.7,5.65,25.39,5.85,2.99,.06,5.66-.14,7.9-.62,3.77-.8,6.13-2.51,7.86-4.29,4.45-4.57,2.05-10.33,2.03-10.37,0,0-.05-.1-.05-.12,0,0-.04-.12-.05-.13-.15-.38-2.83-7.34-8.51-8.08-2.67-.34-11.02-.71-19.93-.71-5.31,0-12.17,.14-17.98,.67-.61,.06-1.2,.11-1.77,.18-5.91,.64-7.61,1.42-8.5,2.83Z"
        />
        <path
          class="cls-358"
          d="M343.13,104.03c-.56,1.36,.5,7.68,13.53,14.59,6.05,3.21,16.87,5.68,25.58,5.84,3.03,.04,5.71-.17,7.96-.67,3.82-.86,6.18-2.6,7.84-4.49,3.85-4.39,1.59-9.88,1.57-9.92,0,0-.05-.1-.05-.12,0,0-.04-.12-.05-.13-.12-.32-2.77-7.27-8.4-7.99-2.66-.34-10.97-.71-19.84-.71-5.22,0-12.07,.14-17.89,.66-.6,.05-1.19,.11-1.76,.17-5.95,.64-7.62,1.4-8.48,2.77Z"
        />
        <path
          class="cls-389"
          d="M343.23,104.06c-.52,1.32,.56,7.55,13.46,14.4,6.09,3.23,17.04,5.71,25.77,5.83,3.07,.03,5.76-.2,8.01-.73,3.86-.91,6.25-2.67,7.82-4.7,3.28-4.21,1.12-9.43,1.1-9.46,0,0-.05-.11-.05-.12,0,0-.05-.13-.05-.13-.1-.25-2.72-7.19-8.29-7.91-2.64-.34-10.93-.71-19.74-.7-5.13,0-11.98,.13-17.81,.65-.6,.05-1.18,.11-1.75,.17-5.98,.64-7.62,1.39-8.46,2.71Z"
        />
        <path
          class="cls-263"
          d="M343.32,104.08c-.48,1.28,.61,7.42,13.39,14.2,6.14,3.26,17.21,5.74,25.95,5.82,3.1,.02,5.82-.24,8.07-.79,3.91-.96,6.34-2.74,7.8-4.9,2.73-4.03,.66-8.97,.64-9.01,0,0-.05-.11-.05-.12,0,0-.05-.13-.05-.13-.07-.19-2.66-7.11-8.18-7.82-2.63-.34-10.88-.7-19.65-.7-5.05,0-11.88,.12-17.73,.64-.59,.05-1.18,.11-1.75,.17-6.02,.64-7.63,1.38-8.44,2.66Z"
        />
        <path
          class="cls-264"
          d="M343.42,104.11c-.44,1.24,.67,7.29,13.31,14,6.18,3.28,17.38,5.77,26.14,5.81,3.14,.01,5.87-.27,8.12-.85,3.96-1.02,6.46-2.8,7.78-5.11,2.21-3.86,.2-8.52,.18-8.56,0,0-.05-.11-.05-.12,0,0-.05-.13-.05-.13-.05-.13-2.61-7.03-8.06-7.74-2.61-.34-10.83-.7-19.56-.7-4.96,0-11.78,.12-17.65,.63-.59,.05-1.17,.11-1.74,.17-6.05,.63-7.64,1.37-8.42,2.6Z"
        />
        <path
          class="cls-375"
          d="M371.21,100.81c-5.36,0-13.06,.14-19.3,.78-6.09,.63-7.64,1.36-8.4,2.55-.39,1.2,.72,7.15,13.24,13.8,6.23,3.31,17.55,5.8,26.33,5.8,3.18,0,5.93-.3,8.17-.9,4.01-1.07,6.62-2.86,7.76-5.31,1.73-3.72-.27-8.06-.29-8.11l-.06-.12-.05-.13c-.02-.06-2.56-6.96-7.95-7.65-2.6-.34-10.78-.7-19.47-.7Z"
        />
      </g>
      <path
        class="cls-4"
        d="M367.73,118.7c-6.32-1.73-12.34-4.51-18.09-7.66-.37-.2-1.29-.75-1.71-.66-.58,.12-.6,.93-.43,1.43,.17,.49,.53,.9,.88,1.28,3.18,3.37,7.27,5.7,11.48,7.55,4.6,2.01,9.18,3.46,14.14,4.26,.59,.1,1.17,.18,1.76,.27,2.94,.41,5.91,.66,8.89,.66,3.33,0,6.22-.32,8.59-.95,2.34-.62,5.24-1.71,6.83-3.63,.71-.86,1.28-2.13,.63-3.21-1.2-2.02-4.74-.4-6.31,.2-7.29,2.77-15.41,2.91-23.06,1.34-1.21-.25-2.42-.54-3.61-.87Z"
      />
    </g>
  </g>
</template>
<script>
export default {
  props: {
    severityClass: String
  },
  methods: {
    changeSeverity(section) {
      this.$emit('changeSeverity', section);
    }
  }
};
</script>
